import type { Addendum, UUID } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getNoteAddendums(patientId: UUID, noteId: UUID): Promise<Addendum[]> {
  const { addendums } = await sharedRequestsTyped.get_note_addendums({
    context: { showLoader: false },
    data: { note_id: noteId, patient_id: patientId },
    urlParams: { patientId },
  });

  return addendums;
}
